import { Flex, useMatchBreakpointsContext, Button, Text } from '@pancakeswap/uikit'
import 'swiper/css'
import 'swiper/css/effect-cards'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import styles from './styles.module.css'
import { EffectCoverflow, EffectCards, Navigation, Pagination } from 'swiper/modules'
import SlideOne from './Slides/FirstSlide'
import SlideTwo from './Slides/SlideSwap'
import SlideThree from './Slides/SlideLiquidity'
import SlideFour from './Slides/SlideFarm'
import SlideFive from './Slides/SlideBoost'
import SlideSix from './Slides/SlideGame'
import 'animate.css'
import 'aos/dist/aos.css'
import AOS from 'aos'
import { Link } from 'react-scroll'
import { IoIosArrowUp } from '@react-icons/all-files/io/IoIosArrowUp'
import { animated } from '@react-spring/web'
import useBounce from 'views/Page/useBounce'
import { IoIosArrowDown } from '@react-icons/all-files/io/IoIosArrowDown'

const HomeSwiper = ({}) => {
  const { isMobile, isMd } = useMatchBreakpointsContext()
  const { style, startBounce, stopBounce } = useBounce()

  return (
    <Flex
      width="100%"
      height="100%"
      minHeight="95vh"
      alignItems="center"
      justifyContent="space-between"
      id="target-swiper"
      flexDirection="column"
    >
      <Flex
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="center"
        mt="1rem"
        style={{ cursor: 'pointer' }}
      >
        {/* <Flex justifyContent="center" alignItems="center">
            <Link to="target-hero" smooth={true} duration={500} onMouseEnter={startBounce} onMouseLeave={stopBounce}>
                <animated.div style={style}>
                      <IoIosArrowUp size="50px" color="#ccc" />
                </animated.div>
                </Link>
          </Flex> */}
      </Flex>
      <Swiper

        effect={'cards'}
        navigation={true}
        grabCursor={true}
        modules={[EffectCards, Navigation]}
        className={styles.swiper}
      >
        <SwiperSlide className={`${styles.baseslide} ${styles.start}`}>
          <SlideOne />
        </SwiperSlide>
        <SwiperSlide className={`${styles.baseslide} ${styles.swap}`}>
          <SlideTwo />
        </SwiperSlide>
        <SwiperSlide className={`${styles.baseslide} ${styles.liquidity}`}>
          <SlideThree />
        </SwiperSlide>
        <SwiperSlide className={`${styles.baseslide} ${styles.farm}`}>
          <SlideFour />
        </SwiperSlide>
        <SwiperSlide className={`${styles.baseslide} ${styles.boost}`}>
          <SlideFive />
        </SwiperSlide>
        <SwiperSlide className={`${styles.baseslide} ${styles.game}`}>
          <SlideSix />
        </SwiperSlide>
      </Swiper>

      <Flex
        flexDirection="column"
        justifyContent="flex-end"
        alignItems="center"
        mt="0rem"
        style={{ cursor: 'pointer' }}
      >
        <Link to="target-social" smooth={true} duration={500} onMouseEnter={startBounce} onMouseLeave={stopBounce}>
          <Flex justifyContent="center" alignItems="center">
            <animated.div style={style}>
              <IoIosArrowDown size="50px" color="#ccc" />
            </animated.div>
          </Flex>
        </Link>
      </Flex>
    </Flex>
  )
}

export default HomeSwiper
